export default __webpack_public_path__ + "static/media/user-profile-default.cf21459d.png";